<template>
  <div class="w-full h-full">
    <div class="w-full h-[30%] md:bg-[#EEDFC8] bg-transparent relative md:static md:flex">
        <div class="h-full md:w-[70%] w-full flex items-center absolute md:static z-20 md:px-2">
            <div class="md:w-full w-[90%] mx-auto flex  md:space-x-3 space-x-1">
                <div :class="avatar ? 'bg-transparent':'bg-white'" class="md:h-36 md:w-36 h-28 w-28 rounded-full flex items-center relative">
                    <div v-if="loadChangeAvatar" class="w-full h-full rounded-full backdrop-blur-sm absolute flex items-center">
                        <div class="
                            rounded-lg
                            flex
                            items-center
                            justify-center
                             text-white
                            w-10
                            mx-auto
                            h-10
                            text-center">
                            <svg aria-hidden="true" class="inline w-44 h-44 mr-2 text-gray-200 animate-spin dark:text-white fill-[#FF9900]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                            </svg>
                        </div>
                    </div>
                    <div class="w-full h-full flex items-center rounded-full overflow-hidden">
                        <div class="w-6 h-6 bg-[#FF9900] absolute md:right-2 right-0 top-2 rounded-full flex items-center overflow-hidden">
                            <input @change="addAvatar" type="file" name="avatar" accept="image/*" id="avatar" class="hidden">
                            <label for="avatar" class="w-full h-full flex items-center cursor-pointer">
                                <img class="w-3 h-3 mx-auto" src="/icons/icons8_edit_1@2x.png" alt="" srcset="">
                            </label>
                        </div>
                        <img v-if="user.avatar" class="w-full h-full object-cover object-center" :src="user.avatar" alt="" srcset="">
                        <img v-if="user.avatar == '' || user.avatar == null" class="w-20 h-20 mx-auto object-cover object-center" src="/logo/mel_logo_noir.png" alt="" srcset="">
                    </div>
                </div>  
                <div class="h-auto flex flex-1 items-center ">
                    <div >
                        <form @submit.prevent="updateMyInfo('name')" class="flex space-x-2">
                            <div>
                                <p id="name" v-if="hidUpdateInfo!='name'" class="md:text-3xl text-xl text-ellipsis font-segoe font-semibold">{{user.name}}</p>
                                <div v-if="hidUpdateInfo=='name'" class="transition duration-1000" :style="'width:'+ width + ';height:'+ height">
                                    <input v-model="form.name" type="text" minlength="1" maxlength="12" class="w-full bg-transparent md:text-3xl text-xl font-segoe font-semibold first-letter:uppercase border-b-[1px] border-black outline-none" :placeholder="user.name" > 
                                </div> 
                            </div>
                            <div class="h-auto cursor-pointer flex space-x-1">
                                <button type="button" v-if="hidUpdateInfo!='name'" @click="updateInfo('name')">
                                    <img class="w-3 h-3 md:w-4 md:h-4" src="/icons/edit_96px.png" alt="" srcset="">
                                </button>
                                <button type="button" v-if="hidUpdateInfo=='name' && loadUpdate!=true" @click="hidUpdateInfo = ''">
                                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                        <g id="surface1">
                                        <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 360.207031 84.433594 L 395.570313 119.796875 L 119.800781 395.566406 L 84.4375 360.203125 Z "/>
                                        <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 395.546875 360.226563 L 360.1875 395.578125 L 84.449219 119.761719 L 119.8125 84.414063 Z "/>
                                        </g>
                                    </svg>
                                </button>
                                <button type="submit" v-if="hidUpdateInfo=='name' && loadUpdate!=true">
                                    <svg class="w-5 h-5 fill-green-500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                        <g id="surface1">
                                        <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 385.625 105.625 L 180 311.25 L 94.375 225.625 L 65.625 254.375 L 165.625 354.375 L 180 368.125 L 194.375 354.375 L 414.375 134.375 Z "/>
                                        </g>
                                    </svg>
                                </button>
                                <div v-if="hidUpdateInfo=='name' && loadUpdate" class="
                                    rounded-lg
                                    flex
                                    items-center
                                    justify-center
                                     text-white
                                    text-center">
                                    <svg aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-white fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                    </svg>
                                </div>
                            </div>
                        </form>
                        <div class="flex space-x-2">
                            <div>
                                <p v-if="user.sexe == 'Femme'" class="text-md md:text-lg font-segoe text-gray-500">{{ $t('entrepreneuse') }}</p>  
                                <p v-if="user.sexe == 'Homme'" class="text-md md:text-lg font-segoe text-gray-500">{{ $t('entrepreneur') }}</p> 
                            </div>
                        </div>
                        <div class="flex items-center md:hidden space-x-2">
                            <div class=" flex space-x-1">
                                <div class="h-auto flex items-center">
                                    <p class="text-xs md:text-base ">{{ $t('niveau') }} {{user.niveau}} <span class="ml-2">{{ user.point }} pts/100</span></p>
                                </div>
                                <div>
                                    <CircleProgressBar class="w-9 h-9" :colorUnfilled="'#FF9900'" :strokeWidth="'10px'" :animationDuration="'3s'"  :value="user.point ? user.point:0" :max="100">{{ user.niveau }}</CircleProgressBar>
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center space-x-2 md:hidden border-gray-300 ">
                            <div class="flex ">
                                <img class="md:w-6 md:h-6 h-4 hidden md:block" src="/icons/icons8_slide_up@2x.png" alt="" srcset="">
                                <img class="md:w-6 md:h-6 h-4 md:hidden" src="/icons/chevronuporange.png" alt="" srcset="">
                                <p class="text-xs md:text-base ml-1">{{ user.nbr_suiveur < 10 && (user.nbr_suiveur > 0) ? '0'+user.nbr_suiveur : user.nbr_suiveur }} {{ $t('abonnes') }}</p>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
        </div>
        <div class="h-full xl:w-[40%] md:w-[50%]  w-full  relative">
            <div class="w-full h-full absolute">
                <div class="w-full h-full relative">
                    <div class="w-full h-full flex md:items-center justify-end md:justify-normal absolute z-10">
                        <div class="md:mx-auto flex flex-row relative space-x-2 p-1 md:p-0 max-w-[90%]">
                            <div class=" h-auto flex flex-shrink-0 md:items-center">
                                <img class="md:h-8 h-6" src="/icons/Group 222@2x.png" alt="" srcset="">
                            </div>
                            <div class="max-w-full">
                                <p class="md:text-2xl text-[0.8rem] text-gray-500 break-words text-center"><span class="font-semibold text-black ">{{ user.ville }},</span> {{ user.quartier }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="w-full h-full relative">
                        <div class="w-full h-full absolute">
                            <div class="w-full h-full relative">
                                <div class="w-full h-full bg-white opacity-20 absolute"></div>
                                <div class="w-full h-full backdrop-blur-sm"></div>  
                            </div>
                        </div>
                        <div class="w-full h-full">
                            <img class="w-full h-full object-cover object-center" src="/images/1280px-Bessengue_City_Douala_08@2x.png" alt="" srcset="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="h-[10%] w-full bg-[#1D04FF] flex items-center">
        <div class="w-[90%] md:w-[98%] mx-auto flex space-x-2">
            <div class="h-auto  flex items-center">
                <img class="w-32 md:w-8 flex-1" src="/icons/attention_480px.png" alt="" srcset="">
            </div>
            <div class="h-auto flex items-center">
                <div class="md:hidden">
                    <Vue3Marquee class=" text-[0.8rem] md:text-base text-white" behavior="" scrolldelay="200" direction="">{{ $t('alert') }}</Vue3Marquee>
                  </div>
                <p class="text-white hidden md:block text-[0.8rem] md:text-base">{{ $t('alert') }}</p>
            </div>     
        </div>
    </div>
    <div class="h-[60%] pb-3 w-full relative md:flex overflow-y-auto xl:overflow-inherit">
        <div class="md:w-[50%] w-full md:h-full flex items-center">
            <div class="w-[90%] mx-auto">
                <form @submit.prevent="updateMyInfo('description')" class="w-full space-y-3">
                    <div class="flex space-x-2 py-2 xl:py-0">
                        <p class=" md:mt-0">{{ $t('description') }}</p>
                        <div class="h-auto flex space-x-1 items-center">
                            <div v-if="hidUpdateInfo!='description'" class="h-auto cursor-pointer flex items-center"  @click="updateInfo('description')">
                                <div class="mx-auto w-6 h-6 rounded-full  flex items-center bg-gray-500">
                                    <img class="w-3 h-3 mx-auto" src="/icons/editblanc.png" alt="" srcset="">
                                </div>  
                            </div>
                            <button type="button" v-if="hidUpdateInfo=='description' && loadUpdate!=true" @click="hidUpdateInfo = ''">
                                <svg class="w-4 h-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 360.207031 84.433594 L 395.570313 119.796875 L 119.800781 395.566406 L 84.4375 360.203125 Z "/>
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 395.546875 360.226563 L 360.1875 395.578125 L 84.449219 119.761719 L 119.8125 84.414063 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <button type="submit" v-if="hidUpdateInfo=='description' && loadUpdate!=true">
                                <svg class="w-5 h-5 cursor-pointer fill-green-500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 385.625 105.625 L 180 311.25 L 94.375 225.625 L 65.625 254.375 L 165.625 354.375 L 180 368.125 L 194.375 354.375 L 414.375 134.375 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <div class="h-auto flex items-center" v-if="hidUpdateInfo=='description' && loadUpdate!=true">
                                <p class="text-xs text-green-500" >
                                    {{ form.description.length }} mot(s)
                                </p>
                            </div>
                            <div v-if="hidUpdateInfo=='description' && loadUpdate" class="
                                rounded-lg
                                flex
                                items-center
                                justify-center
                                text-white
                                text-center">
                                <svg aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-white fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <p id="description" v-if="hidUpdateInfo!='description'" class="text-sm break-words text-gray-500 text-justify">{{ user.description }}</p>
                    <textarea v-model="form.description" v-if="hidUpdateInfo=='description'" type="text" minlength="200" class="text-sm w-full text-gray-500 text-justify bg-transparent first-letter:uppercase outline-none transition" :placeholder="user.description" :style="'height:'+ height"></textarea>
                </form>
            </div>
        </div>
        <div class="md:w-[50%] w-full md:h-full flex items-center ">
            <div class="mx-auto lg:flex lg:flex-wrap lg:justify-between md:w-[85%] w-full px-3 md:px-0 space-y-5 lg:space-y-3">
                <form @submit.prevent="updateMyInfo('quartier')" class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-3">
                    <p class="text-sm">{{ $t('quartier') }}</p>
                    <div class="flex justify-between max-w-full">
                        <div class="h-auto flex items-center flex-auto">
                            <p id="quartier" v-if="hidUpdateInfo!='quartier'" class="text-gray-500">{{user.quartier}}</p> 
                            <div v-if="hidUpdateInfo=='quartier'" class="transition duration-1000" >
                                <input v-model="form.quartier" type="text" minlength="1" class="w-full bg-transparent first-letter:uppercase border-b-[1px] border-black outline-none" :placeholder="user.quartier" :style="'height:'+ height"> 
                            </div>   
                        </div>
                        <div v-if="hidUpdateInfo!='quartier'" @click="updateInfo('quartier')" class="cursor-pointer h-auto flex items-center">
                            <div class="mx-auto w-6 h-6 rounded-full  flex items-center bg-gray-500">
                                <img class="w-3 h-3 mx-auto" src="/icons/editblanc.png" alt="" srcset="">
                            </div>  
                        </div>
                        <div v-if="hidUpdateInfo=='quartier'" class="flex space-x-1">
                            <button type="button" v-if="hidUpdateInfo=='quartier' && loadUpdate!=true" @click="hidUpdateInfo = ''">
                                <svg class="w-4 h-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 360.207031 84.433594 L 395.570313 119.796875 L 119.800781 395.566406 L 84.4375 360.203125 Z "/>
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 395.546875 360.226563 L 360.1875 395.578125 L 84.449219 119.761719 L 119.8125 84.414063 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <button type="submit" v-if="hidUpdateInfo=='quartier' && loadUpdate!=true">
                                <svg class="w-5 h-5 cursor-pointer fill-green-500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 385.625 105.625 L 180 311.25 L 94.375 225.625 L 65.625 254.375 L 165.625 354.375 L 180 368.125 L 194.375 354.375 L 414.375 134.375 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <div v-if="hidUpdateInfo=='quartier' && loadUpdate" class="
                                rounded-lg
                                flex
                                items-center
                                justify-center
                                text-white
                                text-center">
                                <svg aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-white fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </form>
                <form @submit.prevent="updateMyInfo('mon_pays')" class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                    <p class="text-sm">{{ $t('paysorigine') }}</p>
                    <div class="flex justify-between">
                        <div class="flex-1 h-auto flex items-center">
                            <p id="mon_pays" v-if="hidUpdateInfo!='mon_pays'" class="text-gray-500">{{user.mon_pays}}</p> 
                            <div v-if="hidUpdateInfo=='mon_pays'" class="transition duration-1000 w-full" >
                                <select v-model="form.mon_pays" name="" id="" class=" w-full bg-white h-auto  outline-none" :style="'height:'+ height">
                                    <option>Cameroun</option>
                                </select>
                            </div>   
                        </div>
                        <div v-if="hidUpdateInfo!='mon_pays'" @click="updateInfo('mon_pays')" class="cursor-pointer h-auto flex items-center">
                            <div class="mx-auto w-6 h-6 rounded-full flex items-center bg-gray-500">
                                <img class="w-3 h-3 mx-auto" src="/icons/editblanc.png" alt="" srcset="">
                            </div>  
                        </div>
                        <div v-if="hidUpdateInfo=='mon_pays'" class="flex space-x-1">
                            <button type="button" v-if="hidUpdateInfo=='mon_pays' && loadUpdate!=true" @click="hidUpdateInfo = ''">
                                <svg class="w-4 h-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 360.207031 84.433594 L 395.570313 119.796875 L 119.800781 395.566406 L 84.4375 360.203125 Z "/>
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 395.546875 360.226563 L 360.1875 395.578125 L 84.449219 119.761719 L 119.8125 84.414063 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <button type="submit" v-if="hidUpdateInfo=='mon_pays' && loadUpdate!=true">
                                <svg class="w-5 h-5 cursor-pointer fill-green-500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 385.625 105.625 L 180 311.25 L 94.375 225.625 L 65.625 254.375 L 165.625 354.375 L 180 368.125 L 194.375 354.375 L 414.375 134.375 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <div v-if="hidUpdateInfo=='mon_pays' && loadUpdate" class="
                                rounded-lg
                                flex
                                items-center
                                justify-center
                                text-white
                                text-center">
                                <svg aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-white fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </form>
                <form @submit.prevent="updateMyInfo('ville')" class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                    <p class="text-sm">{{ $t('ville') }}</p>
                    <div class="flex justify-between">
                        <div class="h-auto flex items-center flex-1">
                            <p id="ville" v-if="hidUpdateInfo!='ville'" class="text-gray-500">{{ user.ville }}</p>   
                            <div v-if="hidUpdateInfo=='ville'" class="transition duration-1000 w-full" >
                                <select v-model="form.ville" name="" id="" class=" w-full bg-white h-auto  outline-none" :style="'height:'+ height">
                                    <option v-for="ville in villes.sort()" :key="ville.id" :value="ville">{{ ville }}</option>
                                </select>
                            </div>  
                        </div>
                        <div v-if="hidUpdateInfo!='ville' && user.type == 2" @click="updateInfo('ville')" class="cursor-pointer h-auto flex items-center">
                            <div class="mx-auto w-6 h-6 rounded-full flex items-center bg-gray-500">
                                <img class="w-3 h-3 mx-auto" src="/icons/editblanc.png" alt="" srcset="">
                            </div>  
                        </div>
                        <div v-if="hidUpdateInfo=='ville'" class="flex space-x-1">
                            <button type="button" v-if="hidUpdateInfo=='ville' && loadUpdate!=true" @click="hidUpdateInfo = ''">
                                <svg class="w-4 h-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 360.207031 84.433594 L 395.570313 119.796875 L 119.800781 395.566406 L 84.4375 360.203125 Z "/>
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 395.546875 360.226563 L 360.1875 395.578125 L 84.449219 119.761719 L 119.8125 84.414063 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <button type="submit" v-if="hidUpdateInfo=='ville' && loadUpdate!=true">
                                <svg class="w-5 h-5 cursor-pointer fill-green-500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 385.625 105.625 L 180 311.25 L 94.375 225.625 L 65.625 254.375 L 165.625 354.375 L 180 368.125 L 194.375 354.375 L 414.375 134.375 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <div v-if="hidUpdateInfo=='ville' && loadUpdate" class="
                                rounded-lg
                                flex
                                items-center
                                justify-center
                                text-white
                                text-center">
                                <svg aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-white fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </form>
                <form @submit.prevent="updateMyInfo('sexe')" class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                    <p class="text-sm">{{ $t('sexe') }}</p>
                    <div class="flex justify-between">
                        <div class="flex-1 h-auto flex items-center">
                            <p id="sexe" v-if="hidUpdateInfo!='sexe'" class="text-gray-500">{{ user.sexe==$t('homme') ? $t('homme') : $t('femme') }}</p>
                            <div v-if="hidUpdateInfo=='sexe'" class="transition duration-1000 w-full" >
                                <select v-model="form.sexe" name="" id="" class=" w-full bg-white h-auto  outline-none" :style="'height:'+ height">
                                    <option value="Homme">{{ $t('homme') }}</option>
                                    <option value="Femme">{{ $t('femme') }}</option>
                                </select>
                            </div>   
                        </div>
                        <div v-if="hidUpdateInfo!='sexe'" @click="updateInfo('sexe')" class="cursor-pointer h-auto flex items-center">
                            <div class="mx-auto w-6 h-6 rounded-full flex items-center bg-gray-500">
                                <img class="w-3 h-3 mx-auto" src="/icons/editblanc.png" alt="" srcset="">
                            </div>  
                        </div>
                        <div v-if="hidUpdateInfo=='sexe'" class="flex space-x-1">
                            <button type="button" v-if="hidUpdateInfo=='sexe' && loadUpdate!=true" @click="hidUpdateInfo = ''">
                                <svg class="w-4 h-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 360.207031 84.433594 L 395.570313 119.796875 L 119.800781 395.566406 L 84.4375 360.203125 Z "/>
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 395.546875 360.226563 L 360.1875 395.578125 L 84.449219 119.761719 L 119.8125 84.414063 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <button type="submit" v-if="hidUpdateInfo=='sexe' && loadUpdate!=true">
                                <svg class="w-5 h-5 cursor-pointer fill-green-500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 385.625 105.625 L 180 311.25 L 94.375 225.625 L 65.625 254.375 L 165.625 354.375 L 180 368.125 L 194.375 354.375 L 414.375 134.375 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <div v-if="hidUpdateInfo=='sexe' && loadUpdate" class="
                                rounded-lg
                                flex
                                items-center
                                justify-center
                                text-white
                                text-center">
                                <svg aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-white fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </form>
                <form @submit.prevent="updateMyInfo('date_naissance')" class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                    <p class="text-sm">{{ $t('datedenaissance') }}</p>
                    <div class="flex justify-between">
                        <div class="flex-1 h-auto flex items-center">
                            <p id="date_naissance" v-if="hidUpdateInfo!='date_naissance'" class="text-gray-500">{{ user.date_naissance }}</p> 
                            <div v-if="hidUpdateInfo=='date_naissance'" class="transition duration-1000 w-full" >
                                <VueDatePicker v-model="form.date_naissance" class="rounded-lg w-full  outline-none" text-input selectOnFocus @update:model-value="handleDateUpdate" format="yyyy-MM-dd"  :start-date="form.date_naissance" :max-date="MaxYear(new Date())" auto-apply  :enable-time-picker="false" vertical :clearable="false" :month-change-on-scroll="false" no-swipe :locale="langue"  :style="'height:'+ height"/>
                            </div>   
                        </div>
                        <div v-if="hidUpdateInfo!='date_naissance'" @click="updateInfo('date_naissance')" class="cursor-pointer h-auto flex items-center">
                            <div class="mx-auto w-6 h-6 rounded-full flex items-center bg-gray-500">
                                <img class="w-3 h-3 mx-auto" src="/icons/editblanc.png" alt="" srcset="">
                            </div>  
                        </div>
                        <div v-if="hidUpdateInfo=='date_naissance'" class="flex space-x-1">
                            <button type="button" v-if="hidUpdateInfo=='date_naissance' && loadUpdate!=true" @click="hidUpdateInfo = ''">
                                <svg class="w-4 h-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 360.207031 84.433594 L 395.570313 119.796875 L 119.800781 395.566406 L 84.4375 360.203125 Z "/>
                                    <path style=" stroke:none;fill-rule:nonzero;fill:#F44336;fill-opacity:1;" d="M 395.546875 360.226563 L 360.1875 395.578125 L 84.449219 119.761719 L 119.8125 84.414063 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <button type="submit" v-if="hidUpdateInfo=='date_naissance' && loadUpdate!=true">
                                <svg class="w-5 h-5 cursor-pointer fill-green-500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" version="1.1">
                                    <g id="surface1">
                                    <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 385.625 105.625 L 180 311.25 L 94.375 225.625 L 65.625 254.375 L 165.625 354.375 L 180 368.125 L 194.375 354.375 L 414.375 134.375 Z "/>
                                    </g>
                                </svg>
                            </button>
                            <div v-if="hidUpdateInfo=='date_naissance' && loadUpdate" class="
                                rounded-lg
                                flex
                                items-center
                                justify-center
                                text-white
                                text-center">
                                <svg aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-white fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </form>
                <div class=" lg:w-48 w-full space-y-3 ml-2 mt-4 lg:mt-0">
                    <p class="text-sm">{{ $t('langue') }}</p>
                    <div class="flex w-full">
                        <select v-model="langue" @change="changeLangue" name="" id="" class=" w-full bg-white h-auto  outline-none">
                            <option value="fr">Français</option>
                            <option value="en">Anglais</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { CircleProgressBar } from 'vue3-m-circle-progress-bar';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    components: { CircleProgressBar, VueDatePicker},
    data(){
        return{
           user:'',
           readavatar:'',
           avatar:'',
           langue:'',
           loadChangeAvatar:false,
           hidUpdateInfo:'',
           width:'w-0',
           height:'',
           form:{
                name:'',
                sexe:'',
                description:'',
                date_naissance:'',
                ville:'',
                mon_pays:'',
                quartier:''
           },
           inputSelect:'',
           loadUpdate:false,
           villes: [],
           flow:['year', 'month', 'calendar'],
        }
    },
    watch: {
      requestAccueil: {
        handler(newValue) {
          this.user = newValue[0]
        },
        deep: true
      },
    },
    mounted(){
        this.user = this.requestAccueil[0]
        this.villes = this.$store.state.villes
        this.form.ville = this.user.ville
        this.form.sexe = this.user.sexe
        this.form.mon_pays = this.user.mon_pays
        this.form.date_naissance = this.user.date_naissance
        this.langue = localStorage.getItem('langue')
    },
    methods:{
        handleDateUpdate(val) {
            if (!val) {
            this.form.date_naissance = null;
            return;
            }
            
            // Gestion des types (Date ou string)
            const dateObj = typeof val === 'string' ? new Date(val) : val;
            
            // Normalisation indépendante du fuseau
            const utcDate = new Date(Date.UTC(
            dateObj.getFullYear(),
            dateObj.getMonth(),
            dateObj.getDate()
            ));
            
            // Formatage sécurisé
            this.form.date_naissance = utcDate.toISOString().split('T')[0];
            
            // Alternative si problème avec toISOString()
            // this.form.date_naissance = [
            //   utcDate.getUTCFullYear(),
            //   String(utcDate.getUTCMonth() + 1).padStart(2, '0'),
            //   String(utcDate.getUTCDate()).padStart(2, '0')
            // ].join('-');
        },
        MaxYear(date) {
            var max = `${date.getFullYear() - 18}-12-31`
            return max;
        },
 
        format(){
            return this.form.date_naissance
        },

        addAvatar(image) {
            this.avatar = image.target.files[0]
            this.updateAvatar()
            //this.user.avatar = URL.createObjectURL(image.target.files[0])
        },

        updateAvatar(){
            this.etape += 1
            this.loadChangeAvatar = true
            let user = new FormData();
            user.append('avatar', this.avatar);
            user.append('_method', 'PUT');
            this.axios.post(this.requestHttp + 'update_boutique', user,{
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
              },
            }).then(({data}) => {
                this.$store.state.dataAccueil[0] = data
                this.loadChangeAvatar = false
            }).catch(
                error => {
                this.AddLoading = ''
                this.errors = error.response.data.message
            })
        },

        updateMyInfo(){
            this.loadUpdate = true
            let user = new FormData();
            user.append('name', this.form.name);
            user.append('sexe', this.form.sexe);
            user.append('description', this.form.description);
            user.append('date_naissance', new Date(this.form.date_naissance).toJSON());
            user.append('ville', this.form.ville);
            user.append('mon_pays', this.form.mon_pays);
            user.append('quartier', this.form.quartier);
            user.append('_method', 'PUT');
            this.axios.post(this.requestHttp + 'update_boutique', user,{
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
              },
            }).then(({data}) => {
                this.$store.state.dataAccueil[0] = data
                this.form[this.inputSelect] = ''
                this.form.ville = this.$store.state.dataAccueil[0].ville
                this.form.mon_pays = this.$store.state.dataAccueil[0].mon_pays
                this.form.sexe = this.$store.state.dataAccueil[0].sexe
                this.form.date_naissance = this.$store.state.dataAccueil[0].date_naissance
                this.loadUpdate = false
                this.loadChangeAvatar = false
                this.hidUpdateInfo = ''
            }).catch(
                error => {
                this.AddLoading = ''
                this.errors = error.response.data.message
                this.loadUpdate = false
            })
        },

        changeLangue(){
            this.hidlangue = false
            localStorage.setItem('langue', this.langue)
            if(localStorage.getItem('langue') != 'en'){
                this.$i18n.locale = 'fr'
            }else{
                this.$i18n.locale = 'en'
            }
        },

        updateInfo(element){ 
            this.height = document.getElementById(`${element}`).clientHeight  + 'px' 
            this.width = document.getElementById(`${element}`).clientWidth + 'px'
            this.inputSelect = element
            this.hidUpdateInfo = element
        }
    },
    computed:{
      requestHttp(){
        return this.$store.state.api
      },
      requestAccueil(){
        return this.$store.state.dataAccueil
      },
      requestFile(){
        return this.$store.state.apifile
      },
    }
}
</script>

<style>
/* @media (min-width: 1280px) {
    .dp__menu{
        top:0 !important;
        bottom:0 !important;
        left:inherit !important;
        right:0 !important;
        position:absolute !important;
        transform: translate(0%, 0%) !important;
        margin-top: auto;
        margin-bottom: auto;
    }
    .dp__main{
        position:static !important
    }
} */

.dp__input{
    padding:inherit;
    text-align: center;
}
</style>